import { TableContainer, TablePagination, TableHead, TableRow, TableBody, Paper, Table, TableCell, Box, useMediaQuery } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { authAtom, servicessAtom, shopsAtom, tokenAtom } from '../../../../actions/index';
import { useTheme } from '@mui/material/styles';
import axios from 'axios';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${TableCell.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${TableCell.body}`]: {
        fontSize: 14,
    },
}));

const BookingTab = ({ username: lead_username }) => {
    const [auth] = useAtom(authAtom);
    const [shops] = useAtom(shopsAtom);
    const [services] = useAtom(servicessAtom);
    const [token] = useAtom(tokenAtom);
    const [total, setTotal] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(30);
    const [page, setPage] = useState(1);
    const [bookings, setBookings] = useState([]);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const getBookings = useCallback(() => {
        if (token) {
            axios.post('/accounts/customers/get_customer_bookings/', {
                username: lead_username,
                offset: page * rowsPerPage,
                limit: rowsPerPage,
            }, { headers: { Authorization: `Token ${token}` } })
                .then(res => {
                    if (res && res.data) {
                        setBookings(res.data.bookings ?? []);
                        setTotal(res.data.total ?? 0);
                    } else {
                        setBookings([]);
                        setTotal(0);
                    }
                })
                .catch(() => {
                    setBookings([]);
                    setTotal(0);
                });
        }
    }, [token, lead_username, page, rowsPerPage]);

    useEffect(() => {
        getBookings();
    }, [getBookings]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };

    return (
        <Box sx={{ padding: isMobile ? '10px' : '20px' }}>
            <TableContainer
                component={Paper}
                sx={{
                    overflowY: 'auto',
                    width: isMobile ? '100%' : 'calc(100vw - 250px)',
                    maxHeight: isMobile ? '70vh' : '60vh',
                }}
            >
                <TablePagination
                    rowsPerPageOptions={[20, 30, 40, 50]}
                    component="div"
                    count={total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <Table stickyHeader size={isMobile ? 'small' : 'medium'}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Mã đặt</StyledTableCell>
                            <StyledTableCell>Ngày</StyledTableCell>
                            <StyledTableCell>Giờ</StyledTableCell>
                            <StyledTableCell>Liệu trình</StyledTableCell>
                            <StyledTableCell>Tư vấn</StyledTableCell>
                            <StyledTableCell>Kỹ thuật viên</StyledTableCell>
                            <StyledTableCell>Cơ sở</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {bookings.map((item) => {
                            const staffs = [];
                            if (item.technical_staff) {
                                staffs.push(item.technical_staff.full_name);
                            }
                            if (item.second_technical_staff) {
                                staffs.push(item.second_technical_staff.full_name);
                            }
                            return (
                                <TableRow key={item.id}>
                                    <TableCell>{item.id}</TableCell>
                                    <TableCell>{dayjs(item.booking_date).format('DD/MM/YYYY')}</TableCell>
                                    <TableCell>{dayjs(item.booking_date).format('HH:mm')}</TableCell>
                                    <TableCell>{item.service_order.service_name ?? item.service_order.service.name}</TableCell>
                                    <TableCell>{item.advisor ? item.advisor.full_name : ''}</TableCell>
                                    <TableCell>{staffs.join(', ')}</TableCell>
                                    <TableCell>{item.booking_shop ? item.booking_shop.name : ''}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default BookingTab;
